import { useEffect, useState } from 'react';

const useTelegramUser = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const tele = window?.Telegram?.WebApp;
    const userData = tele?.initDataUnsafe?.user.id; //5591115278
    if (userData) {
      setUser(userData);
    }
  }, []);

  return user;
};

export default useTelegramUser;